import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import ComingSoon from '../components/ComingSoon';
import HowItWorks from '../components/HowItWorks';
import Testimonials from '../components/Testimonials';
import AppDownload from '../components/AppDownload';
import Footer from '../components/Footer';
import imgImage18 from "../assets/images/b62c17cc208e792211ff66dab2129a50a8de43f7.png";

export default function Home() {
  return (
    <div className="w-full bg-white min-h-screen flex flex-col items-center overflow-x-hidden">
      <div className="bg-white relative w-full flex flex-col items-center" data-name="landing page">
        <Header />
        <Hero />
        <Services />
        <ComingSoon />
        <HowItWorks />
        <Testimonials />
        <AppDownload />
        {/* bottom background map image - hidden on mobile */}
        <div className="hidden lg:block relative w-full h-[672px] max-w-[1440px] mx-auto overflow-hidden">
          <img alt="Map background" className="absolute inset-0 object-cover size-full pointer-events-none" src={imgImage18} />
        </div>
        <Footer />
      </div>
    </div>
  );
}
